export default __webpack_public_path__ + "static/media/trendDataIconWhite.28b4a16d.svg";